import React, { useEffect } from 'react';
import Swal from 'sweetalert2';

interface CaremapprConfirmationProps {
  open: boolean;
  text?: string;
  icon?: 'warning' | 'success' | 'info' | 'question' | 'error';
  showCloseButton?: boolean;
  showCancelButton?: boolean;
  focusConfirm?: boolean;
  confirmButtonText?: string;
  confirmButtonAriaLabel?: string;
  cancelButtonText?: string;
  cancelButtonAriaLabel?: string;
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void;
  onClose: () => void;
  // Extra SweetAlert2 options override
  options?: Record<string, any>;
}

const CaremapprConfirmation: React.FC<CaremapprConfirmationProps> = ({
  open,
  text = 'Confirm?',
  icon = 'warning',
  showCloseButton = false,
  showCancelButton = true,
  focusConfirm = false,
  confirmButtonText = `Yes`,
  confirmButtonAriaLabel = 'yes',
  cancelButtonText = `No`,
  cancelButtonAriaLabel = 'no',
  onConfirm,
  onCancel,
  onClose,
  options = {},
}) => {
  useEffect(() => {
    if (!open) return;

    Swal.fire({
      icon,
      text,
      showCloseButton,
      showCancelButton,
      focusConfirm,
      confirmButtonText,
      confirmButtonAriaLabel,
      cancelButtonText,
      cancelButtonAriaLabel,
      ...options,
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm?.();
      } else {
        onCancel?.();
      }
      onClose();
    });
    // Only run when `open` changes to true to avoid repeated popups on re-renders
  }, [open]);

  return null;
};

export default CaremapprConfirmation;
